import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { routerMiddleware, connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import logger from "redux-logger";
import appReducer from "./reducers/AppReducer";
import authReducer from "./reducers/AuthReducer";
import TabReducer from "./reducers/TabReducer";
import Appointmentsreducer from "./reducers/AppoinmentReducer";
import { encryptTransform } from "redux-persist-transform-encrypt";
import Tasksreducer from "./reducers/TaskReducer";
import StateReducer from "./reducers/StateReducer";
import PatientReducer from "./reducers/PatientReducer";
import EncounterReducer from "./reducers/EncounterReducer";
import { backDropReducer } from "./reducers/backDropReducer";
import loaderReducer from "./reducers/loaderReducer";
import searchReducer from "./reducers/SearchReducer";
import resetConversationReducer from "./reducers/ResetConversationReducer";
import recordingStatusReducer from "./reducers/RecordinStatusReducer";
import quickAddDataSlice from "./reducers/quickAddDataSlice";
import scribeReducer from "./reducers/ScribeReducer";
import tempDataReducer from "./reducers/TempDataReducer";
import quickAccessReducer from "./reducers/QuickAccessReducer";
import NewVisitSelectedReducer from "./reducers/NewVisitSelectedReducer";
import RegFlowReducer from "./reducers/RegFlowReducer";
import SubscriptionReducer from "./reducers/SubscriptionReducer";
import licenseReducer from "./reducers/LicensingReducer";
import AddCdssSuffixReducer from "./reducers/CdssSuffixReducer";
import conversationalLanguageReducer from "./reducers/ConversationalLanguageReducer";
// import agentSelectionReducer from "./reducers/AgentSelectionReducer";
import { togglePersistChat } from "./actions/TogglePersisChatActions";
import chatReducer from "./reducers/TogglePersistChatReducer";
import SurveyReducer from "./reducers/SurveyReducer";
import ClinicalTrialsReducer from "./reducers/ClinicalTrialsReducer";

export const history = createBrowserHistory();

const secretKey = "hgfyu765uhfhgfgb%$@TGRE^%$#fgedgf";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "app",
    "tabui",
    "auth",
    "patientObj",
    "encounterObj",
    "agentSelection",
  ],
  transforms: [
    encryptTransform({
      secretKey,
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
};

let isDev = true;

if (
  localStorage.getItem("logs") &&
  ![0, 2, 4, 6].includes(Number(localStorage.getItem("logs")))
) {
  isDev = true;
} else {
  isDev = false;
}

const rootReducer = (history) =>
  combineReducers({
    app: appReducer,
    auth: authReducer,
    tabui: TabReducer,
    appointments: Appointmentsreducer,
    tasks: Tasksreducer,
    stateReducer: StateReducer,
    router: connectRouter(history),
    patientObj: PatientReducer,
    encounterObj: EncounterReducer,
    backDropEffect: backDropReducer,
    isLoading: loaderReducer,
    search: searchReducer,
    resetConversation: resetConversationReducer,
    recordingStatus: recordingStatusReducer,
    quickAddData: quickAddDataSlice,
    scribe: scribeReducer,
    tempData: tempDataReducer,
    quickAccessDashboard: quickAccessReducer,
    newVisitSelected: NewVisitSelectedReducer,
    regFlow: RegFlowReducer,
    subscription: SubscriptionReducer,
    license: licenseReducer,
    addCdssSuffix: AddCdssSuffixReducer,
    conversationalLangauge: conversationalLanguageReducer,
    // agentSelection: agentSelectionReducer,
    chat: chatReducer,
    survey:SurveyReducer,
    clinicalTrials:ClinicalTrialsReducer
  });

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

// const preloadedState = {};

let middlewares = [routerMiddleware(history)];
if (isDev) middlewares.push(logger);

const store = configureStore({
  reducer: persistedReducer,
  devTools: isDev,
  middleware: getDefaultMiddleware({
    thunk: true,
    serializableCheck: false,
  }).concat(...middlewares),
  // preloadedState,
});

const persistor = persistStore(store);

export { store, persistor };
